import { render, staticRenderFns } from "./profile-company-details.component.vue?vue&type=template&id=25ecfdcc&scoped=true&"
import script from "./profile-company-details.component.ts?vue&type=script&lang=ts&"
export * from "./profile-company-details.component.ts?vue&type=script&lang=ts&"
import style0 from "./profile-company-details.component.scss?vue&type=style&index=0&id=25ecfdcc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25ecfdcc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VForm,VRow})
